import { render } from "./DressUpTheCharacter.vue?vue&type=template&id=2f44aa7a"
import script from "./DressUpTheCharacter.vue?vue&type=script&lang=js"
export * from "./DressUpTheCharacter.vue?vue&type=script&lang=js"

import "./DressUpTheCharacter.vue?vue&type=style&index=0&id=2f44aa7a&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Taitaen Swegon Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__